import { BadgeAlt } from ".."

interface Props {
  source?: string
}

export function LeadRatesNowBadge({ source }: Props) {
  if (source !== "rates_now") return null
  return <BadgeAlt>Rates.now</BadgeAlt>
}
